// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselHeightController from "./carousel_height_controller"
application.register("carousel-height", CarouselHeightController)

import CarouselTabsController from "./carousel_tabs_controller"
application.register("carousel-tabs", CarouselTabsController)

import ContinuousMatchingController from "./continuous_matching_controller"
application.register("continuous-matching", ContinuousMatchingController)

import CookiebotJavascriptController from "./cookiebot_javascript_controller"
application.register("cookiebot-javascript", CookiebotJavascriptController)

import CountUpController from "./count_up_controller"
application.register("count-up", CountUpController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import MarqueeController from "./marquee_controller"
application.register("marquee", MarqueeController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PreloadImagesController from "./preload_images_controller"
application.register("preload-images", PreloadImagesController)

import RangeController from "./range_controller"
application.register("range", RangeController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ScrollCueController from "./scroll_cue_controller"
application.register("scroll-cue", ScrollCueController)

import ScrollRotateController from "./scroll_rotate_controller"
application.register("scroll-rotate", ScrollRotateController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import ToggleClassController from "./toggle_class_controller"
application.register("toggle-class", ToggleClassController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import VennDiagramRevealController from "./venn_diagram_reveal_controller"
application.register("venn-diagram-reveal", VennDiagramRevealController)
